<template src="./minhas-dividas.html"></template>

<script>
  import acordoCtrl from "@/services/acordo";
  import devedores from "@/services/devedores";
  import usuario from "@/services/usuario"; 
  import { mapMutations } from "vuex";
  import {VMoney} from 'v-money';
  import moment from "moment";
  import axios from "axios";

  function getPosition(string, subString, index) {
    return string.split(subString, index).join(subString).length;
  }
  export default {
    name: 'Negociacao',
    data () {
      return {
        valid: true,
        dialogConfirmation:false,
        menu2: false,
        date2: new Date().toISOString().substr(0, 10),
        dateFormatted2: this.formatDate(new Date().toISOString().substr(0, 10)),
        menu3: false,
        date3: new Date().toISOString().substr(0, 10),
        dateFormatted3: this.formatDate(new Date().toISOString().substr(0, 10)),
        mask: '(##) #####-####',
        modal2: false,
        user: {},
        message: "",
        dialogError: false,
        money: {
          decimal: ',',
          thousands: '.',
          suffix: '',
          precision: 2
        },
        e1: 1,
        dialogParcela: false,
        dialogBoletos: false,
        parcelas: [],
        devedor: {},
        acordo: {},
        acordoBoleto: {},
        tipoParcelamento: [ ],
        dataVencimentos: [],
        headersParcelas: [{
            text: 'Numero',
            value: 'numero'
          },
          {
            text: 'Vencimento',
            value: 'vencimento'
          },
          {
            text: 'Valor',
            value: 'valor'
          }
        ],
        
        headersParcelasBoleto: [{
            text: 'Numero',
            value: 'numero'
          },
          {
            text: 'Vencimento',
            value: 'vencimento'
          },
          {
            text: 'Valor',
            value: 'valor'
          },
          {
            text: 'Boleto',
            value: 'boleto'
          },
          // {
          //   text: 'Modo de Envio',
          //   value: 'email'
          // },
          {
            text: 'Status',
            value: 'stPago'
          },
          {
            text: 'Numero Boleto',
            value: 'numeroBoleto'
          },
          {
            text: 'Pagamento',
            value: 'dtPagamento'
          }
        ]
      }
    },
    async mounted () {
      this.setLoading(true);
      this.user = await usuario.getUsuario(this.$store.getters.user._id);
      this.devedor = await devedores.getDevedoreId(this.user.devedor);
      this.$forceUpdate();
      this.setLoading(false);
    },
    computed: {
      computedDateFormatted2 () {
        return this.formatDate(this.date2)
      },
      computedDateFormatted3 () {
        return this.formatDate(this.date3)
      },
      loading() {
        return this.$store.getters["loading"];
      },
    },
    /*watch: {
      date2 (val) {
        this.dateFormatted2 = this.formatDate(this.date2)
        this.acordo.dtVencimento = this.date2;
      },
      date3 (val) {
        this.dateFormatted3 = this.formatDate(this.date3)
        this.acordo.dtVencimentoParcela = this.date3;
      },
    },*/
    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      allowedDatesParcela (date) {
        let val = moment().add(45, 'days');
        return moment(date) <= val;
      },
      allowedDates (date) {
        let val = moment().add(15, 'days');
        return moment(date) <= val;
      },
      
      async abrirAcordo (acordos, divida) {
        acordos.forEach(acordo => {
          if (acordo.divida == divida._id && acordo.StatusAcordo != 9) {
            this.acordoBoleto = acordo;
          }
        });
        this.dialogBoletos = true;
      },
      
      desabilitarPagamento (acordo, item) {
        if (acordo.StatusAcordo == '1' || acordo.StatusAcordo == '2' || acordo.StatusAcordo == '9' || item.stPago == 'S') {
          return true;
        } else {
          let retorno = false;
          acordo.parcelas.forEach(parcela => {
            if (parcela.numero == (item.numero-1) && parcela.stPago == "N") {
              retorno = true;
            }
          });
          return retorno;
        }
      },
      
      async gerarBoleto (item) {
        if (item.secure_url) {
          
          axios.get(item.secure_url).then((response) => {
            window.open(item.secure_url,'_blank');
          }).catch(async (error)  => {
            let response = await juno.imprimirBoletosBB(item);
            window.open(response.secure_url,'_blank');
          })
        } else {
            let response = await juno.gerarBoletoBB(item);
            if (response) {
              if (response&&response.data&&response.data.erros) {
                this.setError(response.data.erros);
                return;
              }
              
              this.dialogParcela = false;
              this.$forceUpdate();
              this.setDevedor(await devedores.getDevedoreId(this.acordo.devedor));
              this.setError('Boleto gerado com sucesso!');
            }
        }
      },
      getStPago (item) {
        if ((item.juno && item.juno.payments && item.juno.payments.length > 0) || item.stPago == 'S') {
          return 'Pago';
        }
        if (item.secure_url) {
          return 'Boleto BB';
        } 
        if (!item.juno) {
          return 'Boleto não Gerado';
        }
        
        if (moment(item.juno.dueDate) < moment()) {
          return 'Atraso';
        }
        if (item.stPago == 'N') {
          return 'Não Pago';
        } 
      },
      async validarTipoPagamento () {
        if (this.acordo.tipoProposta == '2' && !this.acordo.ValorEntrada) {
          this.setError('O Valor da Entrada deve ser informado!');
          this.setLoading(false);
          return;
        }
        
        let valorMinimo = Math.trunc(Number(this.acordo.ValorAcordo) * (this.acordo.idcliente.percentualAvista /100));
        if (this.acordo.tipoProposta == '2' && Number(this.acordo.ValorEntrada) < valorMinimo) {
          this.setError('O Valor da Entrada deve ser maior que o Valor ( R$ ' +valorMinimo.toFixed(2)+ ').');
          this.setLoading(false);
          return;
        }

        if (this.acordo.tipoProposta == '2' && Number(this.acordo.ValorEntrada) >= Number(this.acordo.ValorAcordo)) {
          this.setError('O Valor da Entrada não pode ser maior que o Valor da Divida, usar o pagamento à vista.');
          this.setLoading(false);
          return;
        }

        
          this.dataVencimentos = [];
          this.tipoParcelamento = [];
          let valorAcordo = Number(this.acordo.ValorAcordo - this.acordo.ValorEntrada);

          for (let index = 1; index <= this.acordo.idcliente.parcelaMaxima; index++) {
            this.tipoParcelamento.push({ tipopParcela: index, descricao: index+"x de R$ " + (valorAcordo/index).toFixed(2) });
          }
          let dia = String(new Date().getDate()).padStart(2, '0');
          if (this.acordo.tipoProposta == 1) {
            for (let index = Number(dia); index < Number(dia)+2; index++) {
              if (index > 28) {
                this.dataVencimentos.push({ diaVencimento: Number(index-28), descricao: "Todo dia " + Number(index-28) });
              } else {
                this.dataVencimentos.push({ diaVencimento: index, descricao: "Todo dia " + index });
              }
            }
          } else if (this.acordo.tipoProposta == 2) {
            for (let index = Number(dia); index < Number(dia)+15; index++) {
              if (index > 28) {
                this.dataVencimentos.push({ diaVencimento: Number(index-28), descricao: "Todo dia " + Number(index-28) });
              } else {
                this.dataVencimentos.push({ diaVencimento: index, descricao: "Todo dia " + index });
              }
            }
          }
          

        this.e1 = 2;
      },
      async calcularParcelas () {
        
        this.setLoading(true);
        
        if (this.acordo.tipoProposta == '2' && !this.acordo.nrParcela) {
          this.setError('O Número de Parcelas deve ser informado!');
          this.setLoading(false);
          return;
        }
        if (!this.acordo.diaVencimento) {
          this.setError('A Data do Vencimento deve ser Informada!');
          this.setLoading(false);
          return;
        }

        let vencimento = new Date().setDate(this.acordo.diaVencimento);
        if (vencimento < (new Date())) {
          vencimento = new Date(vencimento).setMonth(new Date(vencimento).getMonth()+1);
        }

        let parcelas = [];
        if (this.acordo.tipoProposta == '1') {
          parcelas.push({"numero": 1, "valor": Number(this.acordo.ValorAvista), "vencimento": new Date(vencimento).toISOString().substr(0, 10) });
        } else {
          let vencimentoParcela = vencimento;
          let valor = Number(this.acordo.ValorAcordo-this.acordo.ValorEntrada)/this.acordo.nrParcela;

          parcelas.push({"numero": (parcelas.length+1), "valor": this.acordo.ValorEntrada, "vencimento": new Date(vencimentoParcela).toISOString().substr(0, 10) });
          for (let index = 0; index < this.acordo.nrParcela; index++) {
            /*if (index == 0) {
              parcelas.push({"numero": (parcelas.length+1), "valor": valor, "vencimento": new Date(vencimentoParcela).toISOString().substr(0, 10) })
            } else {*/
            vencimentoParcela = new Date(vencimentoParcela).setMonth(new Date(vencimentoParcela).getMonth()+1);
            parcelas.push({"numero": (parcelas.length+1), "valor": valor, "vencimento": new Date(vencimentoParcela).toISOString().substr(0, 10) })
            //}
          }
        }

        
        this.acordo.parcelas = parcelas;
        this.setLoading(false);
        this.e1 = 3;
      },
      async salvar (parcela, acordo) {
        //if (this.$refs.form.validate()) {
        this.acordo = acordo;
        if (!parcela) {
          // let valorAcordo = this.acordo.ValorAcordo.replace('.', '').replace('.', '').replace('.', '');
          // valorAcordo = valorAcordo.replace(',', '.');
          if (!this.acordo.idcliente) {
              this.setError('Regras da Empresa não foram cadastradas, aguarde!');
              this.setLoading(false);
              return;
          }
          if (!this.acordo.idcliente.parcelaMaxima) {
              this.setError('Regras da Empresa não foram cadastradas, aguarde!');
              this.setLoading(false);
              return;
          }
          if (!this.acordo.idcliente.percentualDescontoAvista) {
              this.setError('Regras da Empresa não foram cadastradas, aguarde!');
              this.setLoading(false);
              return;
          }
          if (!this.acordo.idcliente.percentualAvista) {
              this.setError('Regras da Empresa não foram cadastradas, aguarde!');
              this.setLoading(false);
              return;
          }

          let valorAcordo = Number(this.acordo.ValorAcordo);



          //this.acordo.nrParcela = Math.trunc(this.acordo.idcliente.parcelaMaxima/2)
          this.acordo.ValorAvista = valorAcordo - Number(valorAcordo * (this.acordo.idcliente.percentualDescontoAvista /100)).toFixed(2);
          this.acordo.ValorEntrada = Number(valorAcordo * (this.acordo.idcliente.percentualAvista /100)).toFixed(2);
          /*if (this.acordo.ValorEntrada) {

            
          }*/

          
          this.acordo.tipoProposta = '1';
          this.dialogParcela = true;
          return;
        } else {
          
          this.setLoading(true);

          let ValorAcordo = 0;
          
          if (this.acordo.tipoProposta == '1') {
            ValorAcordo = this.acordo.ValorAvista;
          } else if (this.acordo.tipoProposta == '2') {
            ValorAcordo = this.acordo.ValorAcordo;
          }
          if (Number(ValorAcordo) != 
              Number(this.acordo.parcelas.map((item) => {
                      return Number(item.valor) 
                    })
                    .reduce((prev, next) => {return (prev + next)}))) {

            this.message = "O Valor das parcelas (" + this.acordo.parcelas.map((item) => {
                      return Number(item.valor) 
                    })
                    .reduce((prev, next) => {return (prev + next)}) + ") não é igual ao valor do Acordo (" + this.acordo.ValorAcordo + ")";
            this.dialogError = true;
            return;
          }
          this.acordo.devedor = this.devedor._id;
          this.acordo.cliente = this.acordo.idcliente._id;
          this.acordo.user = this.user._id;
          this.acordo.StatusAcordo = '2';
          this.acordo.proposta = '3';
          await acordoCtrl.save(this.acordo);
          this.devedor = await devedores.getDevedoreId(this.user.devedor);
          this.dialogParcela = false;
          this.setLoading(false);
          this.e1 = 4;
          this.$forceUpdate();
        }
        //}
      },
      calculaParcelas (parcelas) {
        if (parcelas && parcelas.length>0) {
          return Number(parcelas.map((item) => Number(item.valor?item.valor:0)).reduce((prev, next) => (prev + next)).toFixed(2));
        } else {
          return 0;
        }
      },
      getTipoProduto (tipo) {
        if (!tipo) return '';
        if (tipo == 1) return 'Boleto';
        else if (tipo == 2) return 'Cheque';
        else if (tipo == 3) return 'Nota';
        else if (tipo == 4) return 'Nota Fiscal';
        else if (tipo == 5) return 'Promissoria';
      },
      getDiasAtraso (data) {
        if (data) {
          let mes = data.substring(getPosition(data, '/', 1)+1,getPosition(data, '/', 2)+1);
          data = data.replace(mes, '');
          data = mes+data;
          let toDate = new Date(data);
          let result = new Date().getTime() - toDate.getTime();
          result = Math.trunc(result/1000/60/60/24);
          return result;
        }
        return null;
        
      },
      getMesesAtraso (data) {
        if (data) {
          let mes = data.substring(getPosition(data, '/', 1)+1,getPosition(data, '/', 2)+1);
          data = data.replace(mes, '');
          data = mes+data;
          let toDate = new Date(data);
          let result = new Date().getTime() - toDate.getTime();
          result = Math.trunc(result/1000/60/60/24/30);
          return result;
        }
        return null;
      },
      getAnosAtraso (data) {
        if (data) {
          let mes = data.substring(getPosition(data, '/', 1)+1,getPosition(data, '/', 2)+1);
          data = data.replace(mes, '');
          data = mes+data;
          let toDate = new Date(data);
          let result = new Date().getTime() - toDate.getTime();
          result = Math.trunc(result/1000/60/60/24/30/12);
          return result;
        }
        return null;
      },
      ...mapMutations({
        setDevedor: "setDevedor",
        setAcordo: "setAcordo",
        setLoading: "setLoading",
        setError: "setError"
      })
    },
    directives: {money: VMoney}
  }
</script>

<style scoped>
  .col {
    margin: 0px !important;
    padding: 0px !important; 
  }
  .label-negociacao {
    line-height: 70px; 
    text-align: right; 
    margin-right: 20px !important;
  }
  .title-div {
    font-size: 30px;
  }
  .title2-div {
    font-size: 20px;
  }
  .card-divida {
    height: 120px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
  }
  .flex-center {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// src/pages/minhas-dividas/minhas-dividas.vue